/**
 * Action Indicator Mapper
 * Maps AEM CTA labels to Kohler DSM icon components
 */

import { DownloadIcon, PrintIcon, ShareIcon, FavoriteIcon } from '@kohler-dsm-library/kohler-icons';

/**
 * Mapping from AEM labels to Kohler DSM icon components
 */
const AEM_LABEL_TO_ICON_MAPPING = {
  download: DownloadIcon,
  print: PrintIcon,
  share: ShareIcon,
  favorite: FavoriteIcon,
};

/**
 * Maps an AEM CTA label to the corresponding Kohler DSM icon component
 * @param {string} aemLabel - The label from AEM CTA
 * @returns {React.Component|null} - The Kohler icon component or null
 */
export const mapAemLabelToIcon = (aemLabel) => {
  if (!aemLabel || typeof aemLabel !== 'string') {
    return null;
  }

  const normalizedLabel = aemLabel.toLowerCase().trim();
  return AEM_LABEL_TO_ICON_MAPPING[normalizedLabel] || null;
};

/**
 * Handles click actions based on CTA label
 * @param {string} label - The CTA label
 */
const handleActionClick = (label) => {
  if (!label) return;

  const normalizedLabel = label.toLowerCase().trim();

  switch (normalizedLabel) {
    case 'print':
      window.print();
      break;
    case 'download':
      console.log('Download action clicked');
      break;
    case 'share':
      console.log('Share action clicked');
      break;
    default:
      console.log(`${label} action clicked`);
      break;
  }
};

/**
 * Creates action indicator props for Kohler DSM ActionIndicator component
 * @param {Object} cta - The CTA object from AEM
 * @returns {Object} - ActionIndicator props
 */
export const createActionIndicatorProps = (cta) => {
  if (!cta) return null;

  const icon = mapAemLabelToIcon(cta.label);

  return {
    icon,
    label: cta.label,
    onClick: () => handleActionClick(cta.label),
  };
};
